4<template>
  <b-modal
    v-model="modal"
    :title="title"
    size="xl"
    :no-enforce-focus="false"
    :no-close-on-backdrop="true"
  >
    <loading
      :active.sync="loading"
      color="#556ee6"
      loader="dots"
      :can-cancel="false"
      :is-full-page="false">
    </loading>
    <div class="row">
      <div class="col-lg-12">
        <b-card-body>
          <form autocomplete="off">
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label>Datas (check-in / check-out) *</label>
                  <select
                    v-model="accommodation.hotel_date_range_id"
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.accommodation.hotel_date_range_id.$error }"
                  >
                    <option :value="null" disabled>Selecione o período</option>
                    <option v-for="r in dateRanges" :key="r.id" :value="r.id">
                      {{ $moment(r.check_in).format('DD/MM/YYYY') }} até {{ $moment(r.check_out).format('DD/MM/YYYY') }}
                    </option>
                  </select>
                  <div v-if="submitted && !$v.accommodation.hotel_date_range_id.required" class="invalid-feedback">
                    O campo é obrigatório.
                  </div>
                  <small class="text-muted">Os quartos desta acomodação serão reservados para este período.</small>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Categoria *</label>
                  <select
                    id="name"
                    v-model="accommodation.category_id"
                    name="name"
                    placeholder="Ex: Basic, Deluxe, etc"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.accommodation.category_id.$error
                    }"
                  >
                    <option value="null" disabled>Selecione uma categoria</option>
                    <option v-for="item in categories" :key="item.id" :value="item.id">{{ item.name }}</option>
                  </select>
                  <div
                    v-if="submitted && !$v.accommodation.category_id.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="form-group">
                  <label for="name">Quantidade de Quartos *</label>
                  <input
                    id="name"
                    v-model="accommodation.qty"
                    name="name"
                    type="number"
                    placeholder="Ex: 10"
                    class="form-control"
                    :class="{
                      'is-invalid': submitted && $v.accommodation.qty.$error
                    }"
                  />
                  <div
                    v-if="submitted && !$v.accommodation.qty.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="description">Tipo de acomodação *</label>
                  <div
                    v-if="submitted && !$v.accommodation.type_room.required"
                    class="invalid-feedback"
                  >
                    O campo é obrigatório.
                  </div>
                  <div class="item-row d-flex justify-content-center">
                      <div class="col-item-2 d-flex" v-for="(bed, i) in beds" :key="i">
                        <div class="item-mb-3 w-100">
                          <label class="card-radio-label mb-2">
                            <input type="radio"  class="card-radio-input" :value="bed.value" name="type_bed" :id="bed.value" v-model="accommodation.type_room"/>
                            <div class="card-radio">
                              <div class="d-flex flex-column align-items-center">
                                <div class="d-flex align-items-center">
                                  <svg v-for="(bed, i) in bed.capacity" :key="i" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" class="icon icon-tabler icons-tabler-filled icon-tabler-bed">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M3 6a1 1 0 0 1 .993 .883l.007 .117v6h6v-5a1 1 0 0 1 .883 -.993l.117 -.007h8a3 3 0 0 1 2.995 2.824l.005 .176v8a1 1 0 0 1 -1.993 .117l-.007 -.117v-3h-16v3a1 1 0 0 1 -1.993 .117l-.007 -.117v-11a1 1 0 0 1 1 -1z"/>
                                    <path d="M7 8a2 2 0 1 1 -1.995 2.15l-.005 -.15l.005 -.15a2 2 0 0 1 1.995 -1.85z" />
                                  </svg>
                                </div>
                                <span>{{ bed.label }}</span>
                                <span class="text-muted font-size-11">{{ bed.capacity }} {{ bed.capacity > 1 ? 'Pessoas' : 'Pessoa' }}</span>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
                  <label for="obs">Observações</label>
                  <textarea
                    id="obs"
                    v-model="accommodation.obs"
                    name="obs"
                    placeholder="Informações adicionais sobre a acomodação..."
                    class="form-control"
                    rows="3"
                  >
                  </textarea>
                </div>
              </div>
            </div>
          </form>
        </b-card-body>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="secondary" @click="close()">Cancelar</b-button>
      <button type="submit" class="btn btn-primary mr-1" :disabled="user.role !== 'Admin'" @click="saveAccommodation()">Salvar</button>
    </template>
  </b-modal>
</template>
<script>
// Import component
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { mapActions, mapState } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import { errorMessage, successMessage } from '@/components/alertsMessages'
import { show as showHotel } from '../services'
import { EventBus } from '@/eventBus'

export default {
  components: {
    Loading
  },
  props: {
    idHotel: {
      type: Number || String,
      default: null
    }
  },
  data () {
    return {
      title: 'Nova Acomodação',
      loading: true,
      fullPage: true,
      submitted: false,
      beds: [
        {
          value: 'Single',
          label: 'Single',
          capacity: 1,
          svg: 1
        },
        {
          value: 'Duplo Cama Casal',
          label: 'Duplo Cama Casal',
          capacity: 2,
          svg: 1
        },
        {
          value: 'Duplo Twin',
          label: 'Duplo Twin',
          capacity: 2,
          svg: 2
        },
        {
          value: 'Triplo Twin',
          label: 'Triplo Twin',
          capacity: 3,
          svg: 3
        },
        {
          value: 'Quádruplo Twin',
          label: 'Quádruplo Twin',
          capacity: 4,
          svg: 4
        }
      ],
      accommodation: {
        category_id: null,
        type_room: null,
        qty: null,
        hotel_date_range_id: null
      },
      dateRanges: [],
      modal: false,
      modalForm: false
    }
  },
  validations: {
    accommodation: {
      category_id: { required },
      type_room: { required },
      qty: { required },
      hotel_date_range_id: { required }
    }
  },
  mounted () {
  },
  methods: {
    ...mapActions('hotelAccommodation', {
      getAccommodation: 'getAccommodation',
      postData: 'save'
    }),
    ...mapActions('hotelCategory', {
      getAll: 'getAll'
    }),
    getCategories () {
      let params = {
        hotel_id: this.idHotel || null,
        search: null,
        limit: 100,
        page: 1
      }
      this.params = params
      this.getAll(this.params).then((res) => {
      }).catch(error => {
        console.log(error)
      })
    },
    loadItem (id) {
      if (id) {
        this.title = 'Editar Acomodação'
        this.getAccommodation(id).then((data) => {
          this.accommodation = this.data
        }).then(() => {
          this.loading = false
        })
      }
    },
    open (id = null) {
      this.modal = true
      this.loading = true
      this.getCategories()
      this.loadDateRanges()
      if (id) {
        this.loadItem(id)
        return
      }
      this.accommodation = { category_id: null, type_room: null, qty: null, hotel_date_range_id: null }
      this.loading = false
    },
    async loadDateRanges () {
      if (!this.idHotel) return
      try {
        const res = await showHotel(this.idHotel)
        const hotel = (res && res.data && res.data.data) ? res.data.data : (res ? res.data : null)
        this.dateRanges = (hotel && hotel.date_ranges) ? hotel.date_ranges : []
        if (this.dateRanges.length === 1 && !this.accommodation.hotel_date_range_id) {
          this.accommodation.hotel_date_range_id = this.dateRanges[0].id
        }
      } catch (e) {
        this.dateRanges = []
      }
    },
    async saveAccommodation () {
      this.submitted = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        window.scroll(0, 0)
        return
      }
      this.loading = true
      this.accommodation.hotel_id = this.idHotel
      this.accommodation.capacity = this.beds.find(item => item.value === this.accommodation.type_room).capacity
      await this.postData(this.accommodation).then(res => {
        let message = 'Sucesso: Dados armazenados com sucesso.'
        let delay = 2500
        this.loading = false
        // Ao reduzir a quantidade, o backend só remove quartos VAGOS. Se algum
        // ficou de fora por estar ocupado, o operador precisa saber — senão a
        // acomodação passa a declarar menos quartos do que existem.
        const kept = res && res.data ? res.data.rooms_kept_occupied : 0
        if (kept > 0) {
          errorMessage('Atenção: ' + kept + ' quarto(s) não puderam ser removidos porque estão ' +
            'ocupados. Libere as alocações e ajuste a quantidade novamente.')
        }
        successMessage(message, delay)
        this.close()
        this.$emit('created')
        EventBus.$emit('roomAdded', 1)
      }).catch((err) => {
        errorMessage('Alerta: ' + err.message)
        this.loading = false
      })
    },
    close () {
      this.modal = false
      this.accommodation = {}
      this.$v.$reset()
      this.$emit('created')
    }
  },
  computed: {
    ...mapState('auth', ['user']),
    ...mapState('event', ['setting']),
    ...mapState('hotelAccommodation', { data: 'accommodation' }),
    ...mapState('hotelCategory', ['categories'])
  },
  watch: {
    modal () {
      if (!this.modal) {
        this.close()
      }
    }
  }
}
</script>
<style scoped>
.vld-overlay.is-full-page {
    z-index: 1051 !important;
}
.modal-header {
  background: #000 !important;
  color: #fff;
}
.border-gray {
  border: 1px solid #e9e9e9;
}
.item-row {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;
}
.col-item-2 {
  flex: 1 1 0;
  max-width: 200px;
  min-width: 150px;
  display: flex;
  justify-content: center;
  height: 150px;
}
.item-mb-3 {
  width: 100%;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.card-radio-label {
  display: block;
  width: 100%;
}

.card-radio {
  display: flex;
  justify-content: center;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
  background-color: #fff;
}

.card-radio svg {
  margin-bottom: 8px;
}

.card-radio span {
  display: block;
}
</style>
